import React from "react";

const LOGO_URL = `${process.env.PUBLIC_URL || ""}/spc-logo.jpg`;

// Print-only cover page (page 1 of the PDF). Hidden on screen.
export default function PdfCover({ athlete, planName, weekLabel, goal, weekAverage, weeklyDemand }) {
  const stats = [
    ["Avg Energy", weekAverage?.energy, "kcal"],
    ["Avg Protein", weekAverage?.protein, "g"],
    ["Avg Carbs", weekAverage?.carb, "g"],
    ["Weekly Load", weeklyDemand, ""],
  ];
  return (
    <div className="pdf-cover">
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
        <img src={LOGO_URL} alt="Performance Nutrition" style={{ height: 84, width: 84, objectFit: "contain", border: "1px solid #d4d4d4" }} />
        <p className="cover-accent" style={{ fontWeight: 900, textTransform: "uppercase", fontSize: 26, letterSpacing: "-0.02em", margin: 0 }}>
          Performance Nutrition
        </p>
        <p className="cover-muted" style={{ textTransform: "uppercase", letterSpacing: "0.28em", fontSize: 12, margin: 0 }}>
          Weekly Nutrition Plan
        </p>
      </div>

      <div style={{ textAlign: "center" }}>
        <p className="cover-muted" style={{ textTransform: "uppercase", letterSpacing: "0.2em", fontSize: 11, margin: "0 0 8px" }}>Prepared for</p>
        <p style={{ fontWeight: 900, fontSize: 40, textTransform: "uppercase", letterSpacing: "-0.02em", margin: 0, lineHeight: 1.05 }}>
          {athlete || planName || "Athlete"}
        </p>
        {weekLabel && <p className="cover-accent" style={{ fontSize: 16, margin: "14px 0 0", letterSpacing: "0.02em" }}>{weekLabel}</p>}
        <p className="cover-muted" style={{ fontSize: 13, textTransform: "capitalize", margin: "6px 0 0" }}>Goal: {goal}</p>
      </div>

      <div style={{ display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap" }}>
        {stats.map(([label, value, unit]) => (
          <div key={label} style={{ border: "1px solid #d4d4d4", padding: "14px 20px", minWidth: 120, textAlign: "center" }}>
            <p className="cover-muted" style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.16em", margin: "0 0 6px" }}>{label}</p>
            <p className="cover-accent" style={{ fontWeight: 900, fontSize: 24, margin: 0 }}>
              {value ?? "—"}{unit && <span style={{ fontSize: 12, fontWeight: 500, marginLeft: 3 }}>{unit}</span>}
            </p>
          </div>
        ))}
      </div>

      <p className="cover-muted" style={{ textAlign: "center", fontSize: 11, letterSpacing: "0.1em" }}>
        Powered by SPC · smartperformancecoaching.co.uk
      </p>
    </div>
  );
}
